import jwtDecode from 'jwt-decode';

/**
 * @returns {Object|null}
 */
export const getVoiceToken = () => global.localStorage.getItem('ns_v_t');

export const getDecoded = () => {
  const token = getVoiceToken();

  if (!token) {
    return null;
  }

  return jwtDecode(token);
};

/**
 * @param voiceToken
 */
export const setVoiceToken = (voiceToken) => {
  global.localStorage.setItem('ns_v_t', voiceToken);
};
